<ng-container *ngIf="selectedContactComponent; else notSelectedContact">
  <ng-container *ngIf="this.selected">
    <ng-container [ngTemplateOutlet]="showSelectedCondition"> </ng-container>
  </ng-container>
</ng-container>
<ng-template #notSelectedContact>
  <ng-container [ngTemplateOutlet]="showSelectedCondition"> </ng-container>
</ng-template>

<ng-template #showSelectedCondition>
  <div class="team-cardlist">
    <div class="team-list" (click)="onClick()">
      <ng-container *ngIf="selectedContactComponent; else notSelectedGroup">
        <ng-container [ngTemplateOutlet]="showGroup"> </ng-container>
      </ng-container>
      <ng-template #notSelectedGroup>
        <div class="group-container initials-border">
          <span class="privacy-icon" *ngIf="selected; else showInitials">
            <mat-icon svgIcon="done-icon" aria-hidden="false"></mat-icon>
          </span>
        </div>
        <ng-template #showInitials>
          <ng-container [ngTemplateOutlet]="showGroup"> </ng-container>
        </ng-template>
      </ng-template>
      <div class="team-info">
        <div class="team-name">{{ team?.team_name || '-' }}</div>
        <ng-container *ngIf="isOnMIQ != null">
          <div class="contactcard-icon">
            <label *ngIf="isOnMIQ" class="miq-icon" l10nTranslate>shared.miq</label>
          </div>
        </ng-container>
        <div class="members-container">
          <button mat-button [matMenuTriggerFor]="menu" (click)="getTeamMembers($event)">
            <span class="members-label" l10nTranslate> shared.viewMembers </span>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="members-menu" xPosition="after" yPosition="below">
            <div class="members-menu-header">
              <span class="members-label-email" l10nTranslate> shared.viewMemberEmail </span>
            </div>
            <button mat-menu-item *ngFor="let member of teamMembers$ | async">
              {{ member?.email }}
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="assign-bgcolor" *ngIf="selectedContactComponent && isUserAllowed" (click)="removeTeam()" miqStopClick>
        <mat-icon>close</mat-icon>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #showGroup>
  <div class="group-container" [ngStyle]="{ 'background-color': color }">
    <mat-icon>group</mat-icon>
  </div>
</ng-template>
